<template>
  <div class="Article noSel">
    <div class="banner">
      <img src="../../assets/images/article/ArticleBanner.png" alt="" />
      <div class="bospied">
        <div class="dev">亚马逊头条</div>
        <div class="bo">为您提供最新政策规则、开店服务动态</div>
        <div class="per">与全面官方资讯</div>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <ul>
          <li :class="{ avt: setIndex == 1000 }" @click="setCat(1000)">
            最新文章
          </li>
          <li
            :class="{ avt: index == setIndex }"
            v-for="(item, index) in categories"
            :key="index"
            @click="setCat(index, item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="boxWrap" v-if="list != ''">
          <div
            class="box"
            v-for="(item, index) in list"
            :key="index"
            @click="golink('ArticleDetail?id=' + item.id)"
          >
            <div class="img" v-if="item.cover">
              <img :src="item.cover" alt="" />
            </div>
            <div class="img" v-else></div>
            <div class="cont">
              <div class="name">{{ item.title }}</div>
              <div class="dev">
                {{ item.subTitle }}
              </div>
              <div class="fot">
                <div class="time">
                  {{ item.author }} · {{ item.publicTime }}
                </div>
                <div class="tis">
                  <div class="icon">
                    <img src="../../assets/images/article/view.png" alt="" />
                  </div>
                  <div class="num">{{ status(item.visit) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="isAdd" v-if="isData" @click="viewData()">查看更多</div>
          <div class="noData" v-else>没有更多数据</div>
        </div>
        <div class="boxWrap" v-else>
          <div class="noData">暂无数据</div>
        </div>
      </div>
      <div class="right">
        <div class="rightWrap" id="fixedBar" :class="{ fixedBar: isFixed }">
          <ul>
            <li class="avt">热门文章</li>
          </ul>
          <div class="boxWrap">
            <div
              class="box"
              v-for="(item, index) in hot"
              :key="index"
              @click="golink('ArticleDetail?id=' + item.id)"
            >
              <div class="img" v-if="item.cover">
                <img :src="item.cover" alt="" />
              </div>
              <div class="img" v-else></div>
              <div class="cont">
                <div class="name">{{ item.title }}</div>
                <div class="dev">
                  {{ item.publicTime }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Article",
  components: {},
  data: function () {
    return {
      list: [],
      hot: [],
      currPage: 1,
      pageSize: 15,
      totalPage: 0,
      isData: true,
      categories: [],
      setIndex: 1000,
      categoryId: "",
      isFixed: false,
      isAbsolute: false,
    };
  },
  created() {
    this.getTweets();
    this.getHot();
    this.getCategories();
  },
  computed: {
    status(v) {
      return function (v) {
        if (v >= 10000) {
          return (v / 10000).toFixed(1) + "W";
        } else if (v >= 1000) {
          return (v / 1000).toFixed(1) + "K";
        } else {
          return v;
        }
      };
    },
  },
  mounted() {
    // 设置bar浮动阈值为 #fixedBar 至页面顶部的距离
    // this.offsetTop = document.querySelector('#fixedBar').offsetTop;
    // 开启滚动监听
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 滚动监听 滚动触发的效果写在这里
    handleScroll() {
      var windowHeight = document.body.clientHeight;

      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // console.log()
      if (scrollTop >= 600) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    golink(e) {
      window.open(this.interfaceJson.localUrl + e, true);
    },
    setCat(i, id) {
      this.currPage = 1;
      this.setIndex = i;
      if (id) {
        this.categoryId = id;
        this.getTweets();
      } else {
        this.categoryId = "";
        this.getTweets();
      }
    },
    getCategories() {
      this.$axios
        .get(this.interfaceJson.serverAddress + "/api/tweets/categories")
        .then((res) => {
          let data = res.data;
          if (data.code == 0) {
            this.categories = data.data;
          }
        });
    },
    getTweets(e) {
      this.$axios
        .get(
          this.interfaceJson.serverAddress +
            "/api/tweets/list?page=" +
            this.currPage +
            "&limit=" +
            this.pageSize +
            "&categoryId=" +
            this.categoryId
        )
        .then((res) => {
          let data = res.data;
          if (data.code == 0) {
            if (e == "e") {
              data.data.list.map((item, index) => {
                this.list.push(item);
              });
            } else {
              this.list = data.data.list;
            }

            this.totalPage = data.data.totalPage;
            if (1 > this.totalPage) {
              this.isData = false;
            } else {
              this.isData = true;
            }
          }
        });
    },
    getHot() {
      this.$axios
        .get(this.interfaceJson.serverAddress + "/api/tweets/hot")
        .then((res) => {
          let data = res.data;
          if (data.code == 0) {
            this.hot = data.data;
          }
        });
    },
    viewData() {
      this.currPage++;
      if (this.currPage > this.totalPage) {
        this.isData = false;
      } else {
        this.getTweets("e");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.Article {
  font-family: PingFang SC;
  .banner {
    width: 100%;
    position: relative;
    img {
      width: 100%;
    }
    .bospied {
      position: absolute;
      left: 50%;
      top: 0;
      z-index: 99;
      transform: translate(-50%, 0);
      width: 1200px;
      height: 190px;
      box-sizing: border-box;
      padding: 0 29px;
      text-align: left;
      .name {
        text-align: center;
        font-size: 40px;
        line-height: 28px;
        height: 28px;
        margin-top: 8%;
        color: #fff;
        span {
          font-size: 20px;
          font-weight: bold;
          vertical-align: middle;
          padding: 0 5px;
          line-height: 28px;
          color: #fff;
        }
      }
      .dev {
        font-size: 44px;
        font-weight: 600;
        color: #fff;
        line-height: 62px;
        margin-top: 121px;
      }
      .bo {
        height: 25px;
        font-size: 26px;
        font-family: PingFang SC;
        line-height: 39px;
        margin-top: 10px;
        color: #fff;
      }
      .per {
        margin-top: 15px;
        font-size: 26px;
        line-height: 39px;
        color: #fff;
      }
    }
  }
  .content {
    width: 1140px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 548px;
    .left {
      width: 800px;
      ul {
        height: 71px;
        line-height: 71px;
        display: flex;
        // border-bottom: 1px solid #E8E8E8;
        li {
          margin: 0 9px;
          position: relative;
          font-size: 16px;
          color: #57616c;
          cursor: pointer;
        }
        .avt {
          color: #000000;
        }
        .avt::after {
          content: "";
          width: 100%;
          height: 1px;
          left: 0;
          bottom: 1px;
          position: absolute;
          background-color: #178aff;
        }
      }
      .boxWrap {
        .box {
          display: flex;
          justify-content: space-between;
          padding: 30px 0;
          cursor: pointer;
          border-top: 1px solid #e8e8e8;
          .img {
            width: 258px;
            height: 170px;
            background: #178aff;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .cont {
            width: 522px;
            .name {
              line-height: 25px;
              font-size: 18px;
              height: 49.6px;
              color: #000000;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .dev {
              margin-top: 20px;
              color: #999999;
              line-height: 21px;
              font-size: 14px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              height: 41.6px;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .fot {
              display: flex;
              justify-content: space-between;
              margin-top: 37px;
              .time {
                line-height: 21px;
                color: #999999;
                font-size: 12px;
              }
              .tis {
                line-height: 21px;
                color: #999999;
                font-size: 12px;
                display: flex;
                align-items: center;
                .icon {
                  width: 14px;
                  height: 10px;
                  img {
                    width: 100%;
                    vertical-align: top;
                  }
                  margin-right: 3px;
                }
              }
            }
          }
        }
        .box:hover .cont .name {
          color: #178aff;
        }
      }
    }
    .right {
      width: 310px;
      position: relative;
      .rightWrap {
        width: 310px;
      }
      .fixedBar {
        position: fixed;
        height: calc(100vh - 351px);
        overflow: auto;
        top: 83px;
        z-index: 999;
        width: 330px;
        padding: 0 10px;
        background-color: #fff;
        border-radius: 2px;
      }
      .Absolutes {
        position: absolute;
        bottom: 10px;
        z-index: 0;
        width: 330px;
        padding: 0 10px;
        background-color: #fff;
        border-radius: 2px;
      }
      ul {
        height: 71px;
        line-height: 71px;
        display: flex;
        // border-bottom: 1px solid #E8E8E8;
        li {
          margin: 0 9px;
          position: relative;
          font-size: 16px;
          color: #57616c;
        }
        .avt {
          color: #000000;
        }
        .avt::after {
          content: "";
          width: 100%;
          height: 1px;
          left: 0;
          bottom: 1px;
          position: absolute;
          background-color: #178aff;
        }
      }
      .boxWrap {
        .box {
          display: flex;
          justify-content: space-between;
          padding: 10px 0;
          cursor: pointer;
          border-top: 1px solid #e8e8e8;
          .img {
            width: 106px;
            height: 70px;
            background: #178aff;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .cont {
            width: 194px;
            .name {
              line-height: 21px;
              font-size: 14px;
              height: 41.6px;
              color: #000000;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .dev {
              margin-top: 12px;
              color: #999999;
              line-height: 21px;
              font-size: 12px;
            }
          }
        }
        .box:hover .cont .name {
          color: #178aff;
        }
      }
    }
  }
  .isAdd {
    width: 122px;
    height: 44px;
    background: #ffffff;
    border: 1px solid #178aff;
    opacity: 1;
    border-radius: 4px;
    font-size: 14px;
    line-height: 44px;
    color: #178aff;
    margin: 31px auto;
    text-align: center;
    cursor: pointer;
  }
  .isAdd:hover {
    background: #178aff;
    color: #fff;
  }
  .noData {
    width: 122px;
    height: 44px;
    background: #ffffff;
    opacity: 1;
    border-radius: 4px;
    font-size: 14px;
    line-height: 44px;
    margin: 31px auto;
    color: #999999;
  }
}
</style>
